import { useState } from 'react';
import type { ToolField } from '@/modules/back-testing/datasets/tools/tool-schema';
import type { CustomToolStep } from '@/types/custom-tool.types';

/** A step tool's arguments, plus any argument the tool no longer lists, kept so it can be seen and cleared. */
export const stepFields = (step: CustomToolStep, fields: ToolField[]): ToolField[] => {
	const known = new Set(fields.map((field) => field.name));
	const carried: ToolField[] = Object.keys(step.args)
		.filter((name) => !known.has(name))
		.map((name) => ({ name, kind: 'text', required: false, description: null, options: [] }));
	return [...fields, ...carried];
};

/** Required arguments always show; optional ones once set, or all of them while asked for. */
export const useShownFields = (step: CustomToolStep, fields: ToolField[]) => {
	const [showOptional, setShowOptional] = useState(false);
	const optional = fields.filter((field) => !field.required);
	return {
		shown: [...fields.filter((field) => field.required), ...optional.filter((field) => showOptional || step.args[field.name])],
		unset: optional.filter((field) => !step.args[field.name]).length,
		showOptional,
		toggleOptional: () => setShowOptional((open) => !open)
	};
};
